// Private Aviation — commercial-use-eligible stock photography (marketing only).
// Same-origin under /assets/aviation-photos/. Licensing recorded in
// /app/frontend/public/brand/STOCK_IMAGERY_LICENSING.md.
// These are MARKETING/CATEGORY images — never actual listing inventory.
const B = "/assets/aviation-photos";

export const AVIATION_PHOTOS = [
  `${B}/aviation-hero.jpg`,
  `${B}/aviation-exterior-1.jpg`,
  `${B}/aviation-flying.jpg`,
  `${B}/aviation-interior-1.jpg`,
  `${B}/aviation-interior-2.jpg`,
];

const aviation = {
  hero: `${B}/aviation-hero.jpg`,
  accent: `${B}/aviation-flying.jpg`,
  gallery: [
    `${B}/aviation-exterior-1.jpg`,
    `${B}/aviation-interior-1.jpg`,
    `${B}/aviation-interior-2.jpg`,
  ],
  card: `${B}/aviation-hero.jpg`,
  social: `${B}/aviation-hero.jpg`,
};
export default aviation;
